import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
	PRODUCTS_REQUEST_LIST,
	PRODUCTS_ROW_REQUEST,
	MY_SERVICEREQUEST_LIST,
	SERVICEREQUEST_LIST,
	DEPT_SERVICEREQUEST_LIST,
	ALL_SERVICEREQUEST_LIST,
	SERVICEREQUEST_LIST_COUNT,
	MY_SERVICEREQUEST_LIST_COUNT,
	DEPT_SERVICEREQUEST_LIST_COUNT,
	ALL_SERVICEREQUEST_LIST_COUNT,
	ITEM_HOD_APPROVAL,
	SR_ITEM_HOD_APPROVAL,
	SRI_STORE_USER_APPROVAL,
	SRI_STORE_HOD_APPROVAL,
	SR_DEPT_HOD_APPROVE_ADD,
	SR_HOD_APPROVE_ADD,
	SERVICEREQUEST_ADD,
	GET_USER_DEPARTMENT,
	SERVICEREQUEST_ROW_DATA,
	SR_MODEL_LIST_OPEN,
	SERVICEREQUEST_DELETE,
	CUSTOM_PRODUCT_ADD,
	C_PRODUCT_RIGHT_SIDEBAR,
	C_PRODUCT_HIDE_RIGHT_SIDEBAR,
	FILTERS_SHOW_RIGHT_SIDEBAR,
	FILTERS_HIDE_RIGHT_SIDEBAR,
	VIEW_SR_LOG_SHOW_RIGHT_SIDEBAR,
	VIEW_LOG_HIDE_RIGHT_SIDEBAR,
	SR_ITEM_TIME_LINE,
	PRODUCT_STORE_QTY,
	PDF_DOWNNLOAD,
	PRODUCT_HISTORY,
	SR_ITEM_UPDATE_IMAGE,
	SERVICE_REQUEST_CLOSE,
	SRQ_FOCUS_POST,
	VIEW_LOG_SR_HIDE_RIGHT_SIDEBAR,
} from "./actionTypes";

import {
	apiError,
	toggleTab,
	getMyServiceReqList,
	productsRequestListSuccessful,
	productRowSuccessful,
	serviceRequestListSuccessful,
	SRListCountSuccessful,
	getReqestRowDetails,
	UserDepartmentSuccessfull,
	serviceRequestRowloading,
	CostomproductAddSuccessful,
	ServiceRequestAddSuccessful,
	materialRequestsuccessfull,
	GetItemTimeLineSuccessful,
	GetItemTimeLine,
	getProductStoreQty,
	getProductStoreQtySuccessful,
	ProductHistorySuccessful,
	getServiceReqList,
	SetParams,
	getAllMeterialReqList,
	serviceRequestsuccessfull,
} from "./actions";
import { getMRList } from "../PurchaseIndent/actions";

import {
	postAdd,
	putImg,
	getList,
	getParamsList,
	postEdit,
	postDelete,
	getDownloadFile,
	postFormData,
} from "../../helpers/Helper";
import swal from "sweetalert";

function* getProductRequestList({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "srstatus") {
				if (data.srstatus[0] !== 0) {
					params.srstatus = data.srstatus.join(",");
				}
			} else {
				if (data[k] !== "") {
					params[k] = data[k];
				}
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/masters/mini/products/",
			params
		);
		yield put(productsRequestListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* getProductRow({ payload }) {
	try {
		const response = yield call(
			getList,
			"/masters/products/" + payload.id,
			{}
		);
		yield put(productRowSuccessful({ response }));
		yield put(getProductStoreQty(payload.id));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* serviceRequestAdd({
	payload: { material, materialId, history, callBack },
}) {
	try {
		if (materialId === "0") {
			const response = yield call(postAdd, "/servicerequest/", material);

			if (response.status === 201) {
				swal("Your Request Added Successfully.!", {
					icon: "success",
				});
				callBack(true, response.data);

				history.push("/srdashboard1");
				yield put(ServiceRequestAddSuccessful(null));
			} else {
				swal("Sorry! Unable to add Request. Please Try Again!", {
					icon: "error",
				});
			}
		} else {
			const response = yield call(
				postEdit,
				"/servicerequest/" + materialId,
				material
			);
			if (response.status === 200) {
				swal("Your Request Edited Successfully.!", {
					icon: "success",
				});
				callBack(true, response.data);
				history.push("/srdashboard1");
				yield put(ServiceRequestAddSuccessful(null));
			} else {
				swal("Sorry! Unable to edit Request. Please Try Again!", {
					icon: "error",
				});
			}
		}
	} catch (error) {
		yield put(apiError(error));
		callBack(false, false);
		swal(
			"There was an error in submitting data, please check the input fields and try again.",
			{
				icon: "error",
			}
		);
	}
}
function* MrItemUpdateImage({ payload: { data } }) {
	try {
		const response = yield call(
			postFormData,
			"/servicerequest/sritemimage",
			data
		);
		// yield put(productRowSuccessful({ response }));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getMyServiceRequestsListCount() {
	try {
		const response = yield call(
			getParamsList,
			"/servicerequest/count/myrequests",
			{}
		);

		yield put(SRListCountSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getDeptServiceRequestsListCount() {
	try {
		const response = yield call(
			getParamsList,
			"/servicerequest/count/mydeprequests",
			{}
		);

		yield put(SRListCountSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getServiceRequestsListCount({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "srstatus") {
				if (data.srstatus[0] !== 0) {
					params.srstatus = data.srstatus.join(",");
				}
			} else if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "" && k !== "no_of_pages") {
					params[k] = data[k];
				}
			}
		}
	}

	try {
		const response = yield call(
			getParamsList,
			"/servicerequest/count/list",
			params
		);

		yield put(SRListCountSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getAllServiceRequestsListCount() {
	try {
		const response = yield call(
			getParamsList,
			"/servicerequest/count/alllist",
			{}
		);

		yield put(SRListCountSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getMyServiceRequestsList({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "srstatus" || k === "pistatus" || k === "mistatus") {
				if (data?.srstatus[0] !== 0) {
					params.srstatus = data.srstatus.join(",");
				}
				if (data.pistatus[0] !== 0) {
					params.pistatus = data.pistatus.join(",");
				}
				if (data.mistatus[0] !== 0) {
					params.mistatus = data.mistatus.join(",");
				}
			} else if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "" && k !== "no_of_pages") {
					params[k] = data[k];
				}
			}
		}
	}

	try {
		const response = yield call(
			getParamsList,
			"/servicerequest/alllist",
			params
		);

		yield put(serviceRequestListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* getServiceRequestsList({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "srstatus" || k === "pistatus" || k === "mistatus") {
				if (data.srstatus[0] !== 0) {
					params.srstatus = data.srstatus.join(",");
				}
				if (data.pistatus[0] !== 0) {
					params.pistatus = data.pistatus.join(",");
				}
				if (data.mistatus[0] !== 0) {
					params.mistatus = data.mistatus.join(",");
				}
			} else if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "" && k !== "no_of_pages") {
					params[k] = data[k];
				}
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/servicerequest/list",
			params
		);
		yield put(serviceRequestListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getDetpServiceRequestsList({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "srstatus" || k === "pistatus" || k === "mistatus") {
				if (data.srstatus[0] !== 0) {
					params.srstatus = data.srstatus.join(",");
				}
				if (data.pistatus[0] !== 0) {
					params.pistatus = data.pistatus.join(",");
				}
				if (data.mistatus[0] !== 0) {
					params.mistatus = data.mistatus.join(",");
				}
			} else if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "" && k !== "no_of_pages") {
					params[k] = data[k];
				}
			}
		}
	}

	try {
		const response = yield call(
			getParamsList,
			"/servicerequest/mydeprequests",
			params
		);

		yield put(serviceRequestListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getAllServiceReqList({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "srstatus" || k === "pistatus" || k === "mistatus") {
				if (data.srstatus[0] !== 0) {
					params.srstatus = data.srstatus.join(",");
				}
				if (data.pistatus[0] !== 0) {
					params.pistatus = data.pistatus.join(",");
				}
				if (data.mistatus[0] !== 0) {
					params.mistatus = data.mistatus.join(",");
				}
			} else if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "" && k !== "no_of_pages") {
					params[k] = data[k];
				}
			}
		}
	}

	try {
		const response = yield call(
			getParamsList,
			"/servicerequest/alllist",
			params
		);
		yield put(serviceRequestListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* userdepartment({ payload: { id } }) {
	try {
		const response = yield call(
			getList,
			"/masters/mini/user/departments/",
			{}
		);
		yield put(UserDepartmentSuccessfull(response));
		yield put(getReqestRowDetails(id));
	} catch (error) {
		swal(error, {
			icon: "error",
		});
	}
}
function* ServiceRequestRowData({ payload }) {
	try {
		const response = yield call(getList, "/servicerequest/" + payload.id);
		yield put(
			serviceRequestsuccessfull({
				response: {
					...response,
					locationLabel: response.location
						? response.location.name
						: "",
					location_id: response.location ? response.location.id : 0,

					sublocationLabel: response.sublocation
						? response.sublocation.name
						: "",
					sublocation_id: response.sublocation
						? response.sublocation.id
						: 0,
					userdepartment_id: response.userdepartment
						? response.userdepartment.id
						: 0,
					userdepartmentLabel: response.userdepartment
						? response.userdepartment.name
						: "",
					department_ids: response.departments,
				},
			})
		);
		if (payload.timeLine && response.sritems.length > 0) {
			yield put(GetItemTimeLine(response.sritems[0].id));
		}
	} catch (error) {
		yield put(apiError(error));
		swal(error, {
			icon: "error",
		});
	}
}
function* DeleteServiceRequest({ payload: { id } }) {
	try {
		const response = yield call(postDelete, "/servicerequest/" + id);
		if (response.status === 204) {
			swal("Your Material Request has been deleted!", {
				icon: "success",
			});
			yield put(
				getMyServiceReqList({
					srstatus: [0],
					search: "",
					start_date: "",
					end_date: "",
					userdepartment: "",
					department: "",
				})
			);
		} else {
			swal("Sorry! Your Material Request has been not deleted!", {
				icon: "error",
			});
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}
function* hodItemApproval({ payload: { data } }) {
	try {
		const response = yield call(
			postAdd,
			"/servicerequest/mydepsriapprove",
			data
		);

		if (response.status === 201) {
			if (data.srstatus === 3)
				swal(
					" Your Material Request Item has been approved sucessfully!",
					{
						icon: "success",
					}
				);
			else if (data.srstatus === 4) {
				swal(
					" Your Material Request Item has been Rejected sucessfully!",
					{
						icon: "success",
					}
				);
			}
			yield put(serviceRequestRowloading(false));
			yield put(getReqestRowDetails(data.materialrequest_id));
		} else {
			if (data.srstatus === 3)
				swal(
					" Sorry! Your Material Request Item has been not approved!",
					{
						icon: "success",
					}
				);
			else if (data.srstatus === 4) {
				swal(
					" Sorry! Your Material Request Item has been not Rejected!",
					{
						icon: "success",
					}
				);
			}
			yield put(serviceRequestRowloading(false));
		}
		// yield put(materialRequestsuccessfull(null));
	} catch (error) {
		yield put(serviceRequestRowloading(false));
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}
function* SRHodItemApproval({ payload: { data } }) {
	try {
		const response = yield call(
			postAdd,
			"/servicerequest/sriapprove",
			data
		);

		if (response.status === 201) {
			if (data.srstatus === 5)
				swal(
					" Your Material Request Item has been approved sucessfully!",
					{
						icon: "success",
					}
				);
			else if (data.srstatus === 6) {
				swal(
					" Your Material Request Item has been Rejected sucessfully!",
					{
						icon: "success",
					}
				);
			}
			yield put(serviceRequestRowloading(false));

			yield put(getReqestRowDetails(data.materialrequest_id));
		} else {
			if (data.srstatus === 5)
				swal(
					" Sorry! Your Material Request Item has been not approved!",
					{
						icon: "success",
					}
				);
			else if (data.srstatus === 6) {
				swal(
					" Sorry! Your Material Request Item has been not Rejected!",
					{
						icon: "success",
					}
				);
			}
			yield put(serviceRequestRowloading(false));
		}
	} catch (error) {
		yield put(serviceRequestRowloading(false));
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}
function* SRISUserApproval({ payload: { data } }) {
	try {
		const response = yield call(
			postAdd,
			"/servicerequest/storeusersriapprove",
			data
		);

		if (response.status === 201) {
			if (data.srstatus === 13) {
				swal(
					" Your Material Request Item has been Cancle sucessfully!",
					{
						icon: "success",
					}
				);
			} else {
				swal(
					" Your Material Request Item has been changed sucessfully!",
					{
						icon: "success",
					}
				);
			}
			yield put(serviceRequestRowloading(false));

			// history.push("/newpirequest/0");
			yield put(
				getMRList({
					// ...this.props.params,
					// MrId: this.props.openSRid,
					// Index: this.props.openSRindex,
					// search: e.target.value,
					page: 1,
				})
			);
		} else {
			swal(" Sorry! Your Material Request Item has been not changed!", {
				icon: "success",
			});

			yield put(serviceRequestRowloading(false));
		}
	} catch (error) {
		yield put(serviceRequestRowloading(false));
		swal("Sorry! Error in getting from the Server", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}

function* SRISHodApproval({ payload: { data } }) {
	//PIData
	// var piItemdata = {
	//   pistatus: 9,
	//   purchaseindent_id: PIData.purchaseindent_id,
	//   piitem_id: PIData.piitem_id,
	//   piisris: PIData.piisris,
	//   t_product_id: data.t_product_id,
	//   t_qty: data.t_qty,
	//   t_unit: data.t_unit,
	//   t_make: data.t_make,
	//   t_description: data.t_description,
	// };
	try {
		const response = yield call(
			postAdd,
			"/servicerequest/storehodsriapprove",
			data
		);

		if (response.status === 201) {
			// yield put(PIDepItemapprove(piItemdata));
			// swal(" Your Item has been changed sucessfully!", {
			//   icon: "success",
			// });

			yield put(serviceRequestRowloading(false));
		} else {
			swal(" Sorry! Your Item has been not changed!", {
				icon: "success",
			});

			yield put(serviceRequestRowloading(false));
		}
	} catch (error) {
		yield put(serviceRequestRowloading(false));
		swal("Sorry! Error in getting from the Server", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}
function* serviceDeptHodApproveRequestAdd({ payload: { material, history } }) {

	yield put(serviceRequestRowloading(true));
	try {
		const response = yield call(postAdd,"/servicerequest/mydepsrapprove",material);
		if (response.status === 201) {
			if (material.srstatus === 3)
				swal(" Your Service Request has been approved sucessfully!", {
					icon: "success",
				});
			else if (material.srstatus === 4) {
				swal(" Your Service Request has been Rejected sucessfully!", {
					icon: "success",
				});
			}

			yield put(serviceRequestRowloading(false));
			yield put(getReqestRowDetails(material.materialrequest_id));

			history.push("/srdashboard2");
		} else {
			if (material.srstatus === 3)
				swal(" Sorry! Your Service Request has been not approved!", {
					icon: "success",
				});
			else if (material.srstatus === 4) {
				swal(" Sorry! Your Service Request has been not Rejected!", {
					icon: "success",
				});
			}
			yield put(serviceRequestRowloading(false));
		}
		yield put(ServiceRequestAddSuccessful(null));
	} catch (error) {
		yield put(serviceRequestRowloading(false));
		swal(error, {
			icon: "error",
		});
	}
}
function* matrialHodApproveRequestAdd({ payload: { material, history } }) {
	yield put(serviceRequestRowloading(true));
	try {
		const response = yield call(
			postAdd,
			"/servicerequest/srapprove",
			material
		);
		if (response.status === 201) {
			if (material.srstatus === 5)
				swal(" Your Material Request has been approved sucessfully!", {
					icon: "success",
				});
			else if (material.srstatus === 6) {
				swal(" Your Material Request has been Rejected sucessfully!", {
					icon: "success",
				});
			}
			yield put(serviceRequestRowloading(false));
			yield put(getReqestRowDetails(material.materialrequest_id));

			history.push("/srdashboard");
		} else {
			if (material.srstatus === 3)
				swal(" Sorry! Your Material Request has been not approved!", {
					icon: "success",
				});
			else if (material.srstatus === 4) {
				swal(" Sorry! Your Material Request has been not Rejected!", {
					icon: "success",
				});
			}
			yield put(serviceRequestRowloading(false));
		}
		yield put(ServiceRequestAddSuccessful(null));
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});
		yield put(apiError(error));
		yield put(serviceRequestRowloading(false));
	}
}

function* AddCustomProduct({ payload: { data } }) {
	try {
		const response = yield call(
			postAdd,
			"/masters/custproducts/",
			data.CustomProductData
		);
		if (response.status === 201) {
			if (data.cPimage.name) {
				const response2 = yield call(
					putImg,
					"/masters/custproducts/" + response.data.id,
					{
						file: data.cPimage,
						name: "image",
					}
				);
				if (response2.status === 200) {
					swal("Your Product Added Successfully.!", {
						icon: "success",
						timer: 1500,
					});
					yield put(CostomproductAddSuccessful(response2));
				} else {
					swal(
						"Sorry! Unable to add Product Image. Please Try Again!",
						{
							icon: "error",
							timer: 1500,
						}
					);
				}
			} else {
				swal("Your Product Added Successfully.!", {
					icon: "success",
					timer: 1500,
				});

				yield put(CostomproductAddSuccessful(response));
			}
			data.FromReset();
			yield put(toggleTab(1));
		} else {
			swal("Sorry! Unable to add Product. Please Try Again!", {
				icon: "error",
			});
		}
	} catch (errors) {
		yield put(apiError(errors));
	}
}
function* itemTimeLine({ payload: { SRItemId } }) {
	try {
		const response = yield call(
			getList,
			"/reports/sritemtimeline/" + SRItemId,
			{}
		);
		yield put(GetItemTimeLineSuccessful(response));
	} catch (error) {
		swal(error, {
			icon: "error",
		});
	}
}
function* productStoreQty({ payload: { ProductID } }) {
	try {
		const response = yield call(
			getList,
			"/focus/stock/" + ProductID, //USE THIS FOR FOCUS INTEGRATION
			// "/masters/user/inventory/product/" + ProductID,//USE THIS FOR WITH OUT FOCUS INTEGRATION
			{}
		);
		yield put(getProductStoreQtySuccessful(response));
	} catch (error) {
		swal("Error in getting Stock data from the Server", {
			icon: "error",
		});
	}
}
function* productHistory({ payload: { ProductID } }) {
	// ProductID = 10225;
	try {
		const response = yield call(
			getList,
			"/workorder/work-orders/history/" + ProductID,{}
		);
		yield put(ProductHistorySuccessful(response));
	} catch (error) {
		swal("Error in getting Stock data from the Server", {
			icon: "error",
		});
	}
}
function* generatePDF({ payload: { SRId } }) {
	try {
		yield call(getDownloadFile, "/servicerequest/pdf/" + SRId);

		// generateRFQasPDF("RFQ",response)
	} catch (error) {
		yield put(apiError(error));
	}
}
//** C-ProductRightSidebar */
/**
 * CProduct the class on body
 * @param {*} cssClass
 */
function manageBodyClass(cssClass, action = "toggle") {
	switch (action) {
		case "add":
			if (document.body) document.body.classList.add(cssClass);
			break;
		case "remove":
			if (document.body) document.body.classList.remove(cssClass);
			break;
		default:
			if (document.body) document.body.classList.toggle(cssClass);
			break;
	}

	return true;
}

function* cProductRightSidebar() {
	try {
		yield call(manageBodyClass, "cp-right-bar-enabled");
	} catch (error) {}
}
function* cProducthideRightSidebar() {
	try {
		yield call(manageBodyClass, "cp-right-bar-enabled", "remove");
	} catch (error) {}
}
function* FilterShowRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled");
	} catch (error) {}
}
function* FilterHideRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled", "remove");
	} catch (error) {}
}
function* ViewLogShowRightSidebar({ payload: { SRId } }) {
	try {
		yield call(manageBodyClass, "timeLine-right-bar-enabled");
		yield put(getReqestRowDetails(SRId, true));
	} catch (error) {}
}
function* ViewLogHideRightSidebar() {
	try {
		yield call(manageBodyClass, "timeLine-right-bar-enabled", "remove");
	} catch (error) {}
}

// Material Request Close

function* CloseServiceRequest({ payload: { id } }) {
	try {
		const response = yield call(postAdd, "/servicerequest/srclose/" + id);
		if (response.status === 200) {
			swal("Your Material Request has been closed!", {
				icon: "success",
			});
			yield put(
				getServiceReqList({
					srstatus: [0],
					pistatus: [0],
					mistatus: [0],
					search: "",
					start_date: "",
					end_date: "",
					userdepartment: "",
					department: "",
				})
			);
			// yield put(SetParams({
			//   srstatus: [0],
			//   pistatus: [0],
			//   mistatus: [0],
			//   search: "",
			//   start_date: "",
			//   end_date: "",
			//   userdepartment: "",
			//   departments: "",
			// }))
		} else {
			swal("Sorry! Your Material Request has been not closed!", {
				icon: "error",
			});
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}

// SRQ Focus post api

function* PostFocusMrq({ payload: { id, data } }) {
	try {
		const response = yield call(
			postAdd,
			"/thirdparty/fsyncmaterialrequest/" + id.id
		);
		if (response.status === 200) {
			if (response.data.result == true) {
				// swal("Your Material Request is successfully synchronised into focus", {
				//   icon: "success",
				// });
				swal({
					title: response.data.msg,
					icon: "error",
				});
			} else {
				swal({
					title: response.data.msg,
					icon: "error",
				});
			}
			yield put(getReqestRowDetails(id.data));
		} else {
			swal(
				"Sorry! selected  Material Request is not posted on focus. please try again!",
				{
					icon: "error",
				}
			);
		}
	} catch (error) {
		swal("Sorry! Permission Denied! +++++++++++++", {
			icon: "error",
		});
		yield put(apiError(error));
	}
}

/*** C-ProductRightSidebar End** */

export function* watchgetProductRequestList() {
	yield takeEvery(PRODUCTS_REQUEST_LIST, getProductRequestList);
}
export function* watchgetRowProductRequest() {
	yield takeEvery(PRODUCTS_ROW_REQUEST, getProductRow);
}
export function* watchServiceRequestAdd() {
	yield takeEvery(SERVICEREQUEST_ADD, serviceRequestAdd);
}
export function* watchgetMyServiceRequestCount() {
	yield takeEvery(
		MY_SERVICEREQUEST_LIST_COUNT,
		getMyServiceRequestsListCount
	);
}
export function* watchgetDeptServiceRequestCount() {
	yield takeEvery(
		DEPT_SERVICEREQUEST_LIST_COUNT,
		getDeptServiceRequestsListCount
	);
}
export function* watchgetAllServiceRequestCount() {
	yield takeEvery(
		ALL_SERVICEREQUEST_LIST_COUNT,
		getAllServiceRequestsListCount
	);
}
export function* watchgetServiceRequestCount() {
	yield takeEvery(SERVICEREQUEST_LIST_COUNT, getServiceRequestsListCount);
}
export function* watchgetMyServiceRequestList() {
	yield takeEvery(MY_SERVICEREQUEST_LIST, getMyServiceRequestsList);
}
export function* watchgetServiceRequestList() {
	yield takeEvery(SERVICEREQUEST_LIST, getServiceRequestsList);
}
export function* watchgetDetpServiceRequestList() {
	yield takeEvery(DEPT_SERVICEREQUEST_LIST, getDetpServiceRequestsList);
}
export function* watchgetAllServiceReqList() {
	yield takeEvery(ALL_SERVICEREQUEST_LIST, getAllServiceReqList);
}
export function* watchGetUserDepartments() {
	yield takeEvery(GET_USER_DEPARTMENT, userdepartment);
}
export function* watchServiceRequestRowData() {
	yield takeEvery(SERVICEREQUEST_ROW_DATA, ServiceRequestRowData);
}
export function* watchServiceRequestlistItem() {
	yield takeEvery(SR_MODEL_LIST_OPEN, ServiceRequestRowData);
}
export function* watchServiceRequestDelete() {
	yield takeEvery(SERVICEREQUEST_DELETE, DeleteServiceRequest);
}
export function* watchItemHodApproval() {
	yield takeEvery(ITEM_HOD_APPROVAL, hodItemApproval);
}
export function* watchISRtemHodApproval() {
	yield takeEvery(SR_ITEM_HOD_APPROVAL, SRHodItemApproval);
}
export function* watchSRISUserApproval() {
	yield takeEvery(SRI_STORE_USER_APPROVAL, SRISUserApproval);
}
export function* watchSRISHodApproval() {
	yield takeEvery(SRI_STORE_HOD_APPROVAL, SRISHodApproval);
}
export function* watchSRDeptHodApproveRequestAdd() {
	yield takeEvery(SR_DEPT_HOD_APPROVE_ADD, serviceDeptHodApproveRequestAdd);
}
export function* watchSRHodApproveRequestAdd() {
	yield takeEvery(SR_HOD_APPROVE_ADD, matrialHodApproveRequestAdd);
}
export function* watchCustomProductAdd() {
	yield takeEvery(CUSTOM_PRODUCT_ADD, AddCustomProduct);
}
export function* watchCPRightSidebar() {
	yield takeEvery(C_PRODUCT_RIGHT_SIDEBAR, cProductRightSidebar);
}
export function* watchCPHideRightSidebar() {
	yield takeEvery(C_PRODUCT_HIDE_RIGHT_SIDEBAR, cProducthideRightSidebar);
}
export function* watchFilterShowRightSidebar() {
	yield takeEvery(FILTERS_SHOW_RIGHT_SIDEBAR, FilterShowRightSidebar);
}
export function* watchfilterHideRightSidebarr() {
	yield takeEvery(FILTERS_HIDE_RIGHT_SIDEBAR, FilterHideRightSidebar);
}
export function* watchViewLogShowRightSidebar() {
	yield takeEvery(VIEW_SR_LOG_SHOW_RIGHT_SIDEBAR, ViewLogShowRightSidebar);
}
export function* watchViewLogHideRightSidebarr() {
	yield takeEvery(VIEW_LOG_SR_HIDE_RIGHT_SIDEBAR, ViewLogHideRightSidebar);
}
export function* watchItemTimeLine() {
	yield takeEvery(SR_ITEM_TIME_LINE, itemTimeLine);
}
export function* watchProductStoreQty() {
	yield takeEvery(PRODUCT_STORE_QTY, productStoreQty);
}
export function* watchgeneratePDF() {
	yield takeEvery(PDF_DOWNNLOAD, generatePDF);
}
export function* watchProductHistory() {
	yield takeEvery(PRODUCT_HISTORY, productHistory);
}
export function* watchSRItemUpdateImage() {
	yield takeEvery(SR_ITEM_UPDATE_IMAGE, MrItemUpdateImage);
}
export function* watchServiceRequestClose() {
	yield takeEvery(SERVICE_REQUEST_CLOSE, CloseServiceRequest);
}
export function* watchMrqFocusPost() {
	yield takeEvery(SRQ_FOCUS_POST, PostFocusMrq);
}
function* ServiceRequestSaga() {
	yield all([
		fork(watchgetProductRequestList),
		fork(watchgetMyServiceRequestList),
		fork(watchgetDetpServiceRequestList),
		fork(watchgetAllServiceReqList),
		fork(watchgetRowProductRequest),
		fork(watchgetDeptServiceRequestCount),
		fork(watchgetAllServiceRequestCount),
		fork(watchgetMyServiceRequestCount),
		fork(watchgetServiceRequestCount),
		fork(watchgetServiceRequestList),
		fork(watchServiceRequestAdd),
		fork(watchGetUserDepartments),
		fork(watchServiceRequestRowData),
		fork(watchServiceRequestlistItem),
		fork(watchServiceRequestDelete),
		fork(watchItemHodApproval),
		fork(watchISRtemHodApproval),
		fork(watchSRISUserApproval),
		fork(watchSRISHodApproval),
		fork(watchSRDeptHodApproveRequestAdd),
		fork(watchSRHodApproveRequestAdd),

		fork(watchCustomProductAdd),
		fork(watchCPRightSidebar),
		fork(watchCPHideRightSidebar),
		fork(watchFilterShowRightSidebar),
		fork(watchfilterHideRightSidebarr),
		fork(watchViewLogShowRightSidebar),
		fork(watchViewLogHideRightSidebarr),
		fork(watchItemTimeLine),
		fork(watchProductStoreQty),
		fork(watchgeneratePDF),
		fork(watchProductHistory),
		fork(watchSRItemUpdateImage),
		fork(watchServiceRequestClose),
		fork(watchMrqFocusPost),
	]);
}

export default ServiceRequestSaga;
